import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TaskTip } from '../TaskTip';

type TaskDetailsProps = Readonly<{
	description: readonly string[];
	reasoning: string | null;
	isCompleted: boolean;
}>;

export const TaskDetails: React.FC<TaskDetailsProps> = ({ description, reasoning, isCompleted }) => {
	return (
		<div className="ml-10 flex max-w-lg flex-col gap-4" data-qa="dynamic-task-details">
			<ul className="ml-4 flex list-disc flex-col gap-2">
				{description.map((line) => (
					<li key={line} className={isCompleted ? 'text-typography-weak' : 'text-typography-strong'}>
						<Text variant="body" size="small" as="span">
							{line}
						</Text>
					</li>
				))}
			</ul>
			{reasoning && <TaskTip reasoning={reasoning} isCompleted={isCompleted} />}
		</div>
	);
};
